// eslint-disable-next-line jira/filename-case
import React, { type ComponentType } from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import type { ReactGadgetProps } from '@jira/global-pages__dashboard-react-gadgets-common/src/types.tsx';
import { FilterResultsEditSkeleton } from '@jira/platform__skeletons/src/ui/dashboard/components/filter-results-edit.tsx';
import { lazyForPaint, type PreloadPriority } from '@atlassian/react-loosely-lazy';
import type { Cleanup } from '@atlassian/react-loosely-lazy/cleanup';
import type { IssueTableGadgetData } from '../../../types.tsx';

const LazyFilterResultsGadgetEdit = lazyForPaint<
	ComponentType<ReactGadgetProps<IssueTableGadgetData>>
>(() => import(/* webpackChunkName: "async-react-filter-results-gadget-edit" */ './main.tsx'));

export const FilterResultsGadgetEdit = (
	props: ReactGadgetProps<IssueTableGadgetData>,
): React.JSX.Element => (
	<Placeholder name="filter-results-gadget-edit" fallback={<FilterResultsEditSkeleton />}>
		<LazyFilterResultsGadgetEdit {...props} />
	</Placeholder>
);

export const preload: (priority?: PreloadPriority) => Cleanup = LazyFilterResultsGadgetEdit.preload;
